import styled from "styled-components";
import { ColumnCentered } from "../../../kanopy-ui/Column/Column";

export const TitleImageContainer = styled(ColumnCentered)``;

export const TitleImage = styled("img")``;
